import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { RegraTributariaNaturezaOperacaoStruct } from '@shared/services/structs/motor-fiscal/regra-tributaria-natureza-operacao.struct';

/**
 * Seção "Regras Tributárias Relacionadas" da aba Reforma Tributária.
 * Réplica estrutural da seção de exceções das demais abas. A listagem e suas
 * colunas já ficam preparadas, mas ainda não há dados nem vínculo definido —
 * o botão apenas notifica o componente pai.
 */
@Component({
    selector: 'app-reforma-tributo-regras-relacionadas-section',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule, MatTableModule],
    templateUrl: './tributo-regras-relacionadas-section.component.html',
    styleUrl: './tributo-regras-relacionadas-section.component.css',
})
export class ReformaTributoRegrasRelacionadasSectionComponent {
    @Input() regrasRelacionadas: RegraTributariaNaturezaOperacaoStruct[] = [];
    // Mapa codigo -> nome do modelo de documento (proprietario db_dfe); resolvido no tab e repassado.
    @Input() nomeModeloPorCodigo: Record<string, string> = {};
    @Output() relacionar = new EventEmitter<void>();
    @Output() editarRegra = new EventEmitter<RegraTributariaNaturezaOperacaoStruct>();
    @Output() removerRegra = new EventEmitter<RegraTributariaNaturezaOperacaoStruct>();

    public displayedColumns = ['regra', 'classificacao', 'modelos', 'status', 'actions'];
}
